import { Component, OnDestroy, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { Campaign } from 'src/app/core/models/lead-campaign';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';
import { LeadCampaignService } from '../lead-campaign.service';

@Component({
  selector: 'app-lead-campaign-list',
  templateUrl: './lead-campaign-list.component.html',
  styleUrls: ['./lead-campaign-list.component.scss']
})
export class LeadCampaignListComponent implements OnInit, OnDestroy {

  public autocomplete = [];
  public isParticipate = false;
  public isAutocomplete = false;
  public openConfirm = false;
  public showClearButton = false;
  public campaign: Campaign;
  public listCampaign = [];
  public loading: boolean = false;
  public screenLoading: boolean = true;
  public isSummary: boolean = false;
  public summaryCampaign: Campaign;
  public timeout: any;
  public isLoading: boolean = true;
  
  public lead_list_search = [
    {
      id: 1,
      title: 'test-1'
    },
    {
      id: 2,
      title: 'test-2'
    }
  ];

  constructor(
    private service: LeadCampaignService,
    private scroll: WindowScrollService,
    private snackService: SnackbarService
  ) { }

  ngOnInit() {
    this.getCampaigns();
  }

  ngOnDestroy() {
    clearTimeout(this.timeout);
  }

  getCampaigns() {
    this.isLoading = true;
    this.service.getCampaignList()
    .pipe(take(1))
    .subscribe(res => {
      this.listCampaign = res.payload;
      this.screenLoading = false;
    }, error => {
      console.error(error);
      this.snackService.show('Erro ao consultar dados, contate o administrador do sistema.', 'error');
    }, () => {
      this.isLoading = false;
    });
  }

  toggleClearButton(toggle: boolean) {
    this.showClearButton = toggle;
  }

  searchElement(event) {
    this.loading = true;
    this.service.autocomplete(event).subscribe(res => {
      this.autocomplete = res;
      this.loading = false;
    });
  }

  elementSelected(event) {
    this.service.getCampaignList(event).subscribe(res => this.listCampaign = res.payload);
  }

  resetSearch() {
    this.showClearButton = false;
    document.getElementById('resetAutocompleteButton2').click();
    this.service.getCampaignList().subscribe(res => this.listCampaign = res.payload);
  }

  public showModalParticipants(data: boolean, values?: Campaign): void {
    if (values?.participating) return;
    
    this.campaign = values;
    this.isParticipate = data;
    if (data) {
      this.scroll.disable();
    } else {
      this.scroll.enable();
    }
  }

  public showSummaryModal(data: boolean, campaign): void {
    this.isSummary = data;
    this.summaryCampaign = campaign;
  }

  public finished(data: boolean): void {
    this.openConfirm = data;
    if (data) {
      this.scroll.disable();
      this.timeout = setTimeout(() => this.getCampaigns(), 800);
    } else {
      this.scroll.enable();
    }
  }

  public closeSummary(data: boolean): void {
    this.isSummary = false;
    if (data) {
      this.timeout = setTimeout(() => this.getCampaigns() , 800);
    }
  }
}
